import {
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	Title,
	Tooltip
} from 'chart.js'

import { Bar } from 'react-chartjs-2'
import { Card } from '@enkla-gui'
import React from 'react'
import Tippy from '@tippyjs/react'

// Register Chart.js components
ChartJS.register(
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend
)

const SkeletonLoader = () => (
	<div class="d-flex align-items-end justify-content-between" style={{height: '200px', padding: '10px'}}>
		{[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(i => (
			<div key={i} class="bg-light rounded-top animate-pulse" style={{
				width: '7%',
				height: `${40 + Math.random() * 50}%`,
				marginRight: '1%'
			}}></div>
		))}
	</div>
)

export default function RevenueChart({ projected, loading }) {
	return (
		<Card title="Förväntad MRR 12 månader framöver" icon="fa fa-chart-bar">
			{loading ? (
				<SkeletonLoader />
			) : projected && projected.labels ? (
				<>
				<Bar
					data={{
						labels: projected.labels,
						datasets: [
							{
								label: 'Prognostiserad intäkt (SEK)',
								data: projected.data,
								backgroundColor: 'rgb(227, 242, 253)',
								borderColor: 'rgb(227, 242, 253)',
								borderWidth: 1,
								borderRadius: 4,
								borderSkipped: false
							}
						]
					}}
					options={{
						responsive: true,
						maintainAspectRatio: false,
						plugins: {
							legend: {
								display: false
							},
							tooltip: {
								mode: 'index',
								intersect: false,
								callbacks: {
									label: function(context) {
										return `Intäkt: ${new Intl.NumberFormat('sv-SE', {
											style: 'currency',
											currency: 'SEK',
											minimumFractionDigits: 0
										}).format(context.raw)}`
									}
								}
							}
						},
						scales: {
							x: {
								display: true,
								grid: {
									display: false
								}
							},
							y: {
								display: true,
								grid: {
									color: 'rgba(0,0,0,0.1)'
								},
								ticks: {
									callback: function(value) {
										return new Intl.NumberFormat('sv-SE', {
											style: 'currency',
											currency: 'SEK',
											minimumFractionDigits: 0
										}).format(value)
									}
								}
							}
						},
						interaction: {
							mode: 'index',
							intersect: false
						}
					}}
					height={200}
				/>
				</>
			) : (
				<div class="text-center p-3">
					<i class="fas fa-spinner fa-spin text-muted"></i>
					<p class="text-muted mt-2 mb-0">Laddar prognos...</p>
				</div>
			)}
		</Card>
	)
}
